import { CardOrderTypes, CardTypes } from './enums';

export const buildConditionalActionsAnswerHistory = state => {
    const sentimentPollAnswerHistory = (state.sentimentPoll.answerHistory || []).map(
        a => ({
            actionIdentifier: a.actionIdentifier,
            // For sentiment poll, the answer ids 1,2,3 correspond to thirds of the scale
            answerId: Math.max(1, Math.min(3, Math.ceil(a.sentimentValue * 3))) // eslint-disable-line
        })
    );
    return sentimentPollAnswerHistory
        .concat(state.poll.answerHistory || [])
        .concat(state.quiz.answerHistory || [])
        .concat(state.checkRegistration.answerHistory || []);
};

export const getNextAction = (
    actions,
    currentActionIdentifier,
    conditionalActionsAnswerHistory,
    cards
) => {
    const currentAction = actions.find(a => a.identifier === currentActionIdentifier);
    const currentCard = cards.find(c => c.id === currentAction.widgetCardId) || {};

    if (currentCard.type === CardTypes.multipleActions) {
        return null;
    }

    const nextOrderAction = currentAction.initialOrder + 1;
    const nextOrderActions = actions.filter(a => a.initialOrder === nextOrderAction);
    if (!nextOrderActions.length && currentCard.sequenceToWidgetCardId) {
        return actions.find(a => a.widgetCardId === currentCard.sequenceToWidgetCardId);
    } else if (!nextOrderActions.length && !currentCard.sequenceToWidgetCardId) {
        return null;
    }

    for (let i = conditionalActionsAnswerHistory.length - 1; i >= 0; i--) {
        const answer = conditionalActionsAnswerHistory[i];
        let actionThatSatisfiesCondition = nextOrderActions.find(
            a =>
                a.initialOrder === nextOrderAction &&
                a.dependentActionId ===
                    parseInt(answer.actionIdentifier.split('|')[0], 10) &&
                (a.dependentActionType
                    ? a.dependentActionType.toLowerCase() ===
                      answer.actionIdentifier.split('|')[1].toLowerCase()
                    : true) &&
                a.dependentResultId === answer.answerId
        );
        if (actionThatSatisfiesCondition) return actionThatSatisfiesCondition;
    }

    return (
        nextOrderActions.find(
            a =>
                a.cardOrderType === CardOrderTypes.nominal &&
                a.initialOrder === nextOrderAction
        ) || null
    );
};

export default getNextAction;
